import React from "react";
import { List, Typography } from "@mui/material";
import CategoryListItem from "./CategoryListItem";

const CategoryList = ({
  noSelections,
  items,
  onDelete,
  onMemberSelection,
  showDescriptions = false,
  requiresDescriptions = false,
  onDescriptionChange = () => {},
}) => {
  const getItemCaption = (item) => {
    return "Region - " + `${item.tag.name}`;
  };

  const getItemBody = (item) => {
    return `${item.name}`;
  };

  return (
    <List dense component="div" role="list" className="categoriesList">
      {noSelections && (
        <Typography variant="body1" className="emptyListText">
          Start Adding Categories From Regions Section
        </Typography>
      )}
      {items.map((value, index) => (
        <CategoryListItem
          key={`${value.id}_${value.tag.id}_${index}`}
          category={value}
          contentCaption={getItemCaption(value)}
          contentBody={getItemBody(value)}
          onDelete={onDelete}
          onMemberSelection={(event) => {
            onMemberSelection(value.id, value.tag.id, event.target.value);
          }}
          showDescriptionInput={showDescriptions}
          requiresDescription={requiresDescriptions}
          onDescriptionChange={(newValue) =>
            onDescriptionChange(value.id, value.tag.id, newValue)
          }
        />
      ))}
    </List>
  );
};

export default CategoryList;
